import ConfirmationModal from '../../components/confirmationModal';

namespace('IO.Views.Preferences', function (exports) {
  var ManagementChangesConfirmation = ConfirmationModal.extend({
    jstTemplate: 'preferences/management_changes_confirmation',

    open: function () {
      this._setupRender();
    },

    _formatModal: function () {
      var onePercent = $(window).width() / 100,
        width = 60,
        top = 180,
        height = 30;

      return {
        top: top,
        left: onePercent * ((100 - width) / 2),
        width: onePercent * width,
        height: onePercent * height,
      };
    },

    _getTemplate: function (data, style) {
      return this.renderTemplate({
        width: style.width,
        height: style.height,
      });
    },
  });

  exports.ManagementChangesConfirmation = ManagementChangesConfirmation;
});
